module.exports = __webpack_public_path__ + "media/recipes/154-1633f02a.png";